import { useContext } from 'react';
import { AppContext } from './appContextRef';

/** Hook to use app state and actions. Must be used within AppProvider. */
export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};
